<div class="title">
  {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CALENDAR.TITLE' | translate }}
</div>
<div class="subtitle">
  {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CALENDAR.DESCRIPTION' | translate }}
</div>
<div class="settings">
  <meeting-scheduler-calendar-selection
    (calendarProviderSelected)="handleCalendarProvider($event)"
    [enableTracking]="enableTracking"
    [isGoogleConfigured]="isGoogleConfigured"
    [isMicrosoftConfigured]="isMicrosoftConfigured"
  >
  </meeting-scheduler-calendar-selection>
</div>
<ng-content></ng-content>
